import Vue from 'vue'
import Vuex from 'vuex'
let Vimeo = require('vimeo').Vimeo

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    foldersArray: [],
    activeNavbar: false,
    graciasView: true,
    sectionCounter: 0,
    sections: {
      counter: 0,
      array: [
        { name: 'heading', clase: 'bg-heading' },
        { name: 'portfolio', clase: 'bg-nosotros' },
        { name: 'nosotros', clase: 'bg-equipo' },
        { name: 'equipo', clase: 'bg-fabrica' },
        { name: 'fabrica', clase: 'bg-portfolio' },
        { name: 'contacto', clase: 'bg-contacto' }
      ]
    },
    sectionAnim: 'section-up',
    selectedArea: undefined,
    switcherRect: undefined,
    windowWidth: 0,
    windowHeight: 0,
    // openedItem: undefined,
    scrollY: 0,
    scrolling: false,
    closeMap: false,
    team: {
      nextVar: false,
      prevVar: false
    },
    teamProfiles: [
      {
        id: 0,
        name: 'ALDANA',
        area: 'AUDIOVISUAL',
        img: '/img/png/AV-Aldi.jpg'
      },
      {
        id: 1,
        name: 'BRENDA',
        area: 'CUENTAS',
        img: '/img/png/CUENTAS-Brenda.jpg'
      },
      {
        id: 2,
        name: 'DANISA',
        area: 'DISEÑO',
        img: '/img/png/DISENO-Danis.jpg'
      },
      {
        id: 3,
        name: 'MARIANA',
        /* name: 'MARIANA ALARCÓN', */
        area: 'DIRECTORA DE PROYECTO \nAUDIOVISUAL',
        img: '/img/png/AV-Maki.jpg'
      },
      {
        id: 4,
        name: 'ENZO',
        area: 'MARKETING DIGITAL',
        img: '/img/png/MARKETING-Enzo.jpg'
      },
      {
        id: 5,
        name: 'GASTÓN',
        /* name: 'GASTÓN SARRÚA', */
        area: 'DIRECTOR DE PROYECTO \nCUENTAS',
        img: '/img/png/CUENTAS-Gaston.jpg'
      },
      {
        id: 6,
        name: 'FERNANDO',
        area: 'CREATIVIDAD',
        img: '/img/png/CREATIVIDAD-Fer.jpg'
      },
      {
        id: 7,
        name: 'JUANPI',
        /* name: 'JUANPI TALAVÁN', */
        area: 'DIRECTOR DE PROYECTO \nCREATIVIDAD',
        img: '/img/png/CREATIVIDAD-Tala.jpg'
      },
      {
        id: 8,
        name: 'GONZALO',
        area: 'IT',
        img: '/img/png/IT-Gonzalo.jpg'
      },

      {
        id: 9,
        name: 'JORDANA',
        /* name: 'JORDANA MATTEUCCI', */
        area: 'DIRECTORA DE PROYECTO \n CUENTAS',
        img: '/img/png/CUENTAS-Jordi.jpg'
      },
      {
        id: 10,
        name: 'JEREMÍAS',
        area: 'AUDIOVISUAL',
        img: '/img/png/AV-Jerre.jpg'
      },
      {
        id: 11,
        name: 'LUCAS',
        area: 'CUENTAS',
        img: '/img/png/CUENTAS-Lucas.jpg'
      },

      {
        id: 12,
        name: 'ENRIQUE',
        area: 'DISEÑO',
        img: '/img/png/DISENO-Kike.jpg'
      },
      {
        id: 13,
        name: 'NAHUEL',
        area: 'IT',
        img: '/img/png/IT-Nahuel.jpg'
      },
      {
        id: 14,
        name: 'RENZO',
        area: 'DISEÑO',
        img: '/img/png/DISENO-Renzo.png'
      },
      {
        id: 15,
        name: 'ROY',
        /* name: 'ROY MILÁN', */
        area: 'DIRECTOR DE PROYECTO \nDISEÑO',
        img: '/img/png/DISENO-Roy.jpg'
      },
      {
        id: 16,
        name: 'SOLEDAD',
        area: 'CREATIVIDAD',
        img: '/img/png/CREATIVIDAD-Sol.jpg'
      },
      {
        id: 17,
        name: 'SUSY',
        area: 'CATADORA GENERAL DE COMESTIBLES',
        img: '/img/png/Susy.png'
      },
      {
        id: 18,
        name: 'DENIS',
        area: 'IT',
        img: '/img/png/IT-Denis.jpg'
      },
      {
        id: 19,
        name: 'VALESKA',
        area: 'CREATIVIDAD',
        img: '/img/png/CREATIVIDAD-Valeska.jpg'
      },
      {
        id: 20,
        name: 'VIVIANA',
        area: 'CREATIVIDAD',
        img: '/img/png/CREATIVIDAD-Vivs.jpg'
      },
      {
        id: 21,
        name: 'PABLO',
        area: 'IT',
        img: '/img/png/IT-Pablo.jpg'
      },
      {
        id: 22,
        name: 'BOMBITA',
        area: 'CATADORA GENERAL DE COMESTIBLES',
        img: '/img/png/Bombita.png'
      },
      {
        id: 23,
        name: 'RAQUEL',
        area: 'APOYO GENERAL Y CREATIVO',
        img: '/img/png/Raquel.png'
      },
      {
        id: 24,
        name: 'SUGAR',
        area: 'REDUCTOR GENERAL DE ESTRÉS',
        img: '/img/png/Sugar.png'
      },

      {
        id: 25,
        name: 'ANDREÍNA',
        /* name: 'ANDREÍNA JONES', */
        area: 'DIRECTORA DE PROYECTO \nCUENTAS',
        img: '/img/png/CUENTAS-Andy.png'
      },
      {
        id: 26,
        name: 'MATÍAS',
        area: 'CUENTAS',
        img: '/img/png/Matias-Mendez.jpg'
      },
      {
        id: 27,
        name: 'FERNANDO',
        area: 'IT',
        img: '/img/png/fernando_lievano.jpg'
      },
      {
        id: 28,
        name: 'LUKE',
        area: 'AUDIOVISUAL',
        img: '/img/png/Luke_Colman.jpg'
      },
      {
        id: 29,
        name: 'FACUNDO',
        area: 'CUENTAS',
        img: '/img/png/FacuH.jpg'
      },
      {
        id: 30,
        name: 'ALDANA',
        area: 'AUDIOVISUAL',
        img: '/img/png/Aldana_Tello.jpg'
      },
      {
        id: 31,
        name: 'ALEJANDRA',
        area: 'MARKETING DIGITAL',
        img: '/img/png/alejandra_brea.jpg'
      },
      {
        id: 32,
        name: 'AUGUSTO',
        area: 'DISEÑO',
        img: '/img/png/Augusto_Toloza.jpg'
      },
      {
        id: 33,
        name: 'FRANCISCO',
        area: 'DISEÑO',
        img: '/img/png/Fachi.jpg'
      },
      /*       {
        id: 34,
        name: 'FRANCISCO',
        area: 'DISEÑO',
        img: '/img/png/Fachi.jpg'
      }, */
      {
        id: 35,
        name: 'LISANDRO',
        area: 'AUDIOVISUAL',
        img: '/img/png/Lisandro.jpg'
      },
      {
        id: 36,
        name: 'VICTORIA',
        area: 'DISEÑO',
        img: '/img/png/Victoria_Zacariaz.jpg'
      },
      {
        id: 37,
        name: 'LARA',
        area: 'AUDIOVISUAL',
        img: '/img/png/Lara_Florentin.jpg'
      },
      {
        id: 38,
        name: 'MARIA EUGENIA',
        area: 'AUDIOVISUAL',
        img: '/img/png/maru_romero.jpg'
      },
      {
        id: 39,
        name: 'VALENTINA',
        area: 'DISEÑO',
        img: '/img/png/Valentina_Sponton.jpg'
      },
      {
        id: 40,
        name: 'NATALIA',
        area: 'ADMIN',
        img: '/img/png/Natalia_Mumare.jpg'
      },
      {
        id: 41,
        name: 'VALENTINA',
        area: 'CREATIVIDAD',
        img: '/img/png/Valentina_Parra.jpg'
      },
      {
        id: 42,
        name: 'IRIS MICAELA',
        area: 'DISEÑO',
        img: '/img/png/Micaela_Robledo.jpg'
      },
      {
        id: 43,
        name: 'LUCÍA',
        area: 'ADMIN',
        img: '/img/png/Luli.jpg'
      },
      {
        id: 44,
        name: 'LOURDES',
        area: 'IT',
        img: '/img/png/lourdes.jpg'
      },
      {
        id: 45,
        name: 'LULIANA',
        area: 'AUDIOVISUAL',
        img: '/img/png/Luli_Maidana.jpg'
      },
      {
        id: 46,
        name: 'DANIELA',
        area: 'MARKETIG DIGITAL',
        img: '/img/png/Daniela_Diseno.jpg'
      },
      {
        id: 47,
        name: 'JUAN',
        area: 'COMUNICACIÓN POLITICA',
        img: '/img/png/Juanza.jpg'
      }

    ],
    areas: [
      {
        id: 0,
        name: 'CUENTAS',
        header: 'El nexo entre agencia, cliente y objetivos.',
        description: 'Se desarrolla la estrategia comunicacional, se establecen las fechas y se brinda seguimiento al proyecto en todo momento.',
        coordinates: {
          x: '28%',
          y: '21%',
          zoom: 1.7
        },
        mobileCoordinates: {
          x: '16%',
          y: '21%',
          zoom: 2.1
        },
        animation: {
          data: null
        }
      },
      {
        id: 1,
        name: 'CREATIVIDAD',
        header: 'Donde nacen las ideas.',
        description: 'En esta área se llevan a cabo las conceptualizaciones, los guiones, la dirección de arte y los lineamientos estéticos del proyecto.',
        coordinates: {
          x: '33%',
          y: '-7%',
          zoom: 1.8
        },
        mobileCoordinates: {
          x: '21.3%',
          y: '-7%',
          zoom: 2.8
        },
        animation: {
          data: null
        }
      },
      {
        id: 2,
        name: 'DISEÑO',
        header: 'La forma y los colores de nuestros proyectos.',
        description: 'Nuestro equipo DG genera recursos estéticos, plantillas, e identidades marcarias completas, sinergizando con las propuestas creativas.',
        coordinates: {
          x: '4.5%',
          y: '4%',
          zoom: 1.8
        },
        mobileCoordinates: {
          x: '-6.5%',
          y: '1%',
          zoom: 2.5
        },
        animation: {
          data: null
        }
      },
      {
        id: 3,
        name: 'AUDIOVISUAL',
        header: 'Cuando todas las piezas cobran vida.',
        description: 'Una vez definidas la idea central e identidad marcaria, el team AV produce los movimientos, efectos y sonidos. También se encargan de rodajes, sesiones de fotos y más.',
        coordinates: {
          x: '-1%',
          y: '25%',
          zoom: 1.6
        },
        mobileCoordinates: {
          x: '-13%',
          y: '22.5%',
          zoom: 1.9
        },
        animation: {
          data: null
        }
      },
      {
        id: 4,
        name: 'MARQUETING DIGITAL',
        header: 'Planificar, publicar, compartir, analizar.',
        description: 'Una vez lista la campaña digital, se comparte al público segmentado. También se elaboran y desarrollan nuevas estrategias en base al comportamiento de sus consumidores.',
        coordinates: {
          x: '14%',
          y: '-16%',
          zoom: 2.2
        },
        mobileCoordinates: {
          x: '5%',
          y: '-19%',
          zoom: 2.9
        },
        animation: {
          data: null
        }
      },
      {
        id: 5,
        name: 'IT',
        header: 'El desarrollo y la maquetación digital.',
        description: 'En IT se produce y testea la funcionalidad, estética y experiencia de una marca en sus canales online. Se llevan a cabo distintos tipos de webs, plataformas y aplicaciones.',
        coordinates: {
          x: '-5%',
          y: '-31%',
          zoom: 1.8
        },
        mobileCoordinates: {
          x: '-17%',
          y: '-31.5%',
          zoom: 3
        },
        animation: {
          data: null
        }
      },
      {
        id: 6,
        name: 'HALL',
        description: null,
        coordinates: {
          x: null,
          y: null,
          zoom: null
        },
        animation: {
          data: null
        }
      },
      {
        id: 7,
        name: 'BAÑO',
        description: null,
        coordinates: {
          x: null,
          y: null,
          zoom: null
        },
        animation: {
          data: null
        }
      },
      {
        id: 8,
        name: 'COCINA',
        description: null,
        coordinates: {
          x: null,
          y: null,
          zoom: null
        },
        animation: {
          data: null
        }
      },
      {
        id: 9,
        name: 'PATIO',
        description: null,
        coordinates: {
          x: null,
          y: null,
          zoom: null
        },
        animation: {
          data: null
        }
      }
    ],
    trabajos: [
      {
        slug: 'tree_almacen',
        cover: '/img/trabajos/1 IMG-Grilla-TreeAlmacen.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/tree-desktop.jpg',
            mobile: '/img/trabajos/brochures/tree-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'bacanal',
        cover: '/img/trabajos/2 IMG-Grilla-Bacanal.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/bacanal-desktop.jpg',
            mobile: '/img/trabajos/brochures/bacanal-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'estetica',
        cover: '/img/trabajos/3 IMG-Grilla-ESTETICA.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/estetica-desktop.jpg',
            mobile: '/img/trabajos/brochures/estetica-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'rsi',
        cover: '/img/trabajos/4 IMG-Grilla-RSI.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/rsi-desktop.jpg',
            mobile: '/img/trabajos/brochures/rsi-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'solo_cruceros',
        cover: '/img/trabajos/5 IMG-Grilla-Solocruceros.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/solo-cruceros-desktop.jpg',
            mobile: '/img/trabajos/brochures/solo-cruceros-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      //
      {
        slug: 'preston',
        cover: '/img/trabajos/11 IMG-Grilla-PRESTON.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/preston-desktop.jpg',
            mobile: '/img/trabajos/brochures/preston-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'leo_paparella',
        cover: '/img/trabajos/12B IMG-Grilla-LeoPaparella.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/leo-paparella-desktop.jpg',
            mobile: '/img/trabajos/brochures/leo-paparella-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'dorika',
        cover: '/img/trabajos/13 IMG-Grilla-DORIKA.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/dorika-desktop.jpg',
            mobile: '/img/trabajos/brochures/dorika-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'curba',
        cover: '/img/trabajos/14 IMG-Grilla-CURBA.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/curba-desktop.jpg',
            mobile: '/img/trabajos/brochures/curba-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'larocca',
        cover: '/img/trabajos/15 IMG-Grilla-LAROCCA.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/larocca-desktop.jpg',
            mobile: '/img/trabajos/brochures/larocca-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      //
      {
        slug: 'bioland',
        cover: '/img/trabajos/6 IMG-Grilla-Bioland.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/bioland-desktop.jpg',
            mobile: '/img/trabajos/brochures/bioland-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'powgen',
        cover: '/img/trabajos/7 IMG-Grilla-Powgen.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/powgen-desktop.jpg',
            mobile: '/img/trabajos/brochures/powgen-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'biamaq',
        cover: '/img/trabajos/8 IMG-Grilla-Biamaq.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/biamaq-desktop.jpg',
            mobile: '/img/trabajos/brochures/biamaq-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'caribe',
        cover: '/img/trabajos/9 IMG-Grilla-Caribe.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/caribe-desktop.jpg',
            mobile: '/img/trabajos/brochures/caribe-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'top_mega',
        cover: '/img/trabajos/10 IMG-Grilla-Topmega.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/topmega-desktop.jpg',
            mobile: '/img/trabajos/brochures/topmega-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      //
      {
        slug: 'guayacan',
        cover: '/img/trabajos/16 IMG-Grilla-Guayacan.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/guayacan-desktop.jpg',
            mobile: '/img/trabajos/brochures/guayacan-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'prokopiuk',
        cover: '/img/trabajos/17 IMG-Grilla-prokopiuk.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/prokopiuk-desktop.jpg',
            mobile: '/img/trabajos/brochures/prokopiuk-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'amanda',
        cover: '/img/trabajos/18 IMG-Grilla-Amanda.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/amanda-desktop.jpg',
            mobile: '/img/trabajos/brochures/amanda-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'cr',
        cover: '/img/trabajos/19 IMG-Grilla-CR.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/cr-desktop.jpg',
            mobile: '/img/trabajos/brochures/cr-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      },
      {
        slug: 'devlights',
        cover: '/img/trabajos/20 IMG-Grilla-devlights.jpg',
        images: [
          {
            desktop: '/img/trabajos/brochures/devlights-desktop.jpg',
            mobile: '/img/trabajos/brochures/devlights-mobile.jpg'
          }
        ],
        idFolder: '',
        videos: []
      }
    ],
    reels: {
      videos: [],
      selectedVideo: null,
      error: null,
      loaded: false
    }
  },
  mutations: {
    toggleNavbar (state) {
      state.activeNavbar = !state.activeNavbar
    },
    closeNavbar (state) {
      state.activeNavbar = false
    },
    openNavbar (state) {
      state.activeNavbar = true
    },
    showGraciasView (state, payload) {
      state.graciasView = payload
    },
    // Fábrica
    setAreaAnimationData (state, payload) {
      state.areas[payload[0]].animation.data = payload[1]
    },
    setSelectedArea (state, payload) {
      state.selectedArea = payload
    },
    setWindowWidth (state) {
      state.windowWidth = window.innerWidth
    },
    setWindowHeight (state) {
      state.windowHeight = window.innerHeight
    },
    setOpenedItem (state, payload) {
      const item = state.portfolio.slider.items.filter(work => work.route === payload)
      state.openedItem = item[0]
    },
    setScrollY (state, payload) {
      state.scrollY = payload
    },
    setCloseMap (state) {
      this.state.closeMap = !this.state.closeMap
    },
    setSectionCounter (state, payload) {
      switch (payload) {
        case 'up':
          state.sections.counter += 1
          break
        case 'down':
          state.sections.counter -= 1
          break
        default:
          break
      }
    },
    goToSection (state, payload) {
      state.sections.counter = payload
    },
    setScrolling (state, payload) {
      state.scrolling = payload
    },
    setSectionAnim (state, payload) {
      state.sectionAnim = payload
    },
    setSwitcherRect (state) {
      let switcher = document.querySelector('#switcher')
      state.switcherRect = switcher.getBoundingClientRect()
    },
    handleTeamSlider (state, payload) {
      switch (payload) {
        case 'next':
          state.team.nextVar = !state.team.nextVar
          break
        case 'prev':
          state.team.prevVar = !state.team.prevVar
          break
      }
    },
    setPortfolioCounter (state, payload) {
      switch (payload) {
        case 'reset':
          state.portfolio.slider.counter = 0
          break
        case 'increase':
          state.portfolio.slider.counter += 1
          break
        case 'decrease':
          state.portfolio.slider.counter -= 1
          break
      }
    },
    setReelSelectedVideo (state, payload) {
      state.reels.selectedVideo = payload
    },
    setVideosAndImages (state) {
      state.foldersArray.forEach(folder => {
        state.trabajos.forEach((trabajo, i) => {
          if (trabajo.slug == folder.folder) {
            state.trabajos[i].idFolder = folder.id
          }
        })
      })
    },
    setVideoIntoTrabajo (state, payload) {
      const { videoData, slug } = payload
      state.trabajos.forEach((trabajo, i) => {
        if (trabajo.slug === slug) {
          state.trabajos[i].videos = [...videoData]
        }
      })
    }
  },
  actions: {
    async getReelVideos (context, payload) {
      context.state.reels.error = null
      context.state.reels.loaded = false
      const VIMEO = new Vimeo(
        'ede41442f41345ff4fdaf8f0031638bd55942837', // client_id
        'Fhaha3y8qVogVFwwyi9dEHUzDalXhado6WbsOsRfXJh+3v5rBDVmx5ZBT/Vo+KOOrKeDDGMoifBMTzy39DXKoXahZwLKjmK1uadebL4zS0CuamiSaGJgxqKl5n4EHRAK', // client_secret
        '7b0f8cebd68cd3eb47b1037c269f4fbc' // access_token
      )
      // let path = `/me/videos?page=${payload}&per_page=10`
      let path = `/me/albums/5932596/videos`
      try {
        await VIMEO.request(
          {
            method: 'GET',
            path
          }, async function (error, body, status_code, headers) {
            try {
              if (error) {
                console.log(error)
              } else {
                console.log(body)
                context.state.reels.videos = body.data
                if (context.state.reels.videos.length > 0) {
                  context.state.reels.selectedVideo = context.state.reels.videos[0]
                  context.state.reels.loaded = true
                } else {
                  context.state.reels.error = 'no-vid'
                }
              }
            } catch (e) {
              context.state.reels.error = 'err'
              throw new Error(e)
            }
          }
        )
      } catch (e) {
      }
    },
    async getReelFolders (context, payload) {
      context.state.reels.error = null
      context.state.reels.loaded = false
      const VIMEO = new Vimeo(
        'ede41442f41345ff4fdaf8f0031638bd55942837', // client_id
        'Fhaha3y8qVogVFwwyi9dEHUzDalXhado6WbsOsRfXJh+3v5rBDVmx5ZBT/Vo+KOOrKeDDGMoifBMTzy39DXKoXahZwLKjmK1uadebL4zS0CuamiSaGJgxqKl5n4EHRAK', // client_secret
        '7b0f8cebd68cd3eb47b1037c269f4fbc' // access_token
      )
      // let path = `/me/videos?page=${payload}&per_page=10`
      let path = `/me/projects`
      try {
        await VIMEO.request(
          {
            method: 'GET',
            path
          }, async function (error, body, status_code, headers) {
            try {
              let foldersFormated = []
              body.data.forEach((folder) => {
                let objjeto = { folder: folder.name, id: folder.uri.split('/')[4] }
                foldersFormated.push(objjeto)
              })
              console.log(foldersFormated)
              context.state.foldersArray = foldersFormated
              console.log(context.state.foldersArray)
              context.commit('setVideosAndImages')
            } catch (e) {
              console.log('error ', e)
              throw new Error(e)
            }
          }
        )
      } catch (e) {
      }
    },
    async getVideosByFolder (context, payload) {
      const { idFolder, slug } = payload

      context.state.reels.error = null
      context.state.reels.loaded = false
      const VIMEO = new Vimeo(
        'ede41442f41345ff4fdaf8f0031638bd55942837', // client_id
        'Fhaha3y8qVogVFwwyi9dEHUzDalXhado6WbsOsRfXJh+3v5rBDVmx5ZBT/Vo+KOOrKeDDGMoifBMTzy39DXKoXahZwLKjmK1uadebL4zS0CuamiSaGJgxqKl5n4EHRAK', // client_secret
        '7b0f8cebd68cd3eb47b1037c269f4fbc' // access_token
      )
      // let path = `/me/videos?page=${payload}&per_page=10`
      let path = `/me/projects/${idFolder}/items`
      try {
        await VIMEO.request(
          {
            method: 'GET',
            path
          }, async function (error, body, status_code, headers) {
            try {
              console.log(body.data)

              context.commit('setVideoIntoTrabajo', { videoData: body.data, slug })
            } catch (e) {
              console.log('error ', e)
              throw new Error(e)
            }
          }
        )
      } catch (e) {
      }
    }
  }
})
